import { useState } from 'react';
import _get from 'lodash/get';
import _isEqual from 'lodash/isEqual';
import useProfileCommonStore from '../use-profile-common-store';

import {
  useProfileDisclosures,
  useProfileGlossaryTerms,
  useTagDefinitions
} from '../../../hooks/api';

const usePageSideRail = () => {
  const { apiConfigBase, commonState } = useProfileCommonStore();

  const disclosureRequest = useProfileDisclosures({ ...apiConfigBase, forPrint: false });
  const glossaryTermRequest = useProfileGlossaryTerms(apiConfigBase);
  const tagDefinitionsRequest = useTagDefinitions(apiConfigBase);

  const [disclosures, setDisclosures] = useState([]);
  const [glossary, setGlossary] = useState([]);
  const [tagDefinitions, setTagDefinitions] = useState([]);

  if (disclosureRequest.isLoaded) {
    const requestData = _get(disclosureRequest, 'data', []).filter(item => {
      return item.module && item.disclosures;
    });
    if (!_isEqual(disclosures, requestData)) {
      setDisclosures(requestData);
    }
  }

  if (glossaryTermRequest.isLoaded) {
    const requestData = _get(glossaryTermRequest, 'data', []).filter(item => {
      return item.term && item.content;
    });
    if (!_isEqual(glossary, requestData)) {
      setGlossary(requestData);
    }
  }

  if (tagDefinitionsRequest.isLoaded) {
    const requestData = _get(tagDefinitionsRequest, 'data', []).filter(item => {
      return item.tag && item.definition;
    });
    if (!_isEqual(tagDefinitions, requestData)) {
      setTagDefinitions(requestData);
    }
  }

  return {
    disclosures,
    glossary,
    tagDefinitions,
    pageOffsetsTop: _get(commonState, 'pageOffsetsTop', 0),
    sideRail: _get(commonState, 'sideRail', {})
  };
};

export default usePageSideRail;
